// extracted by mini-css-extract-plugin
export var hidden = "_tv-0";